import { forwardRef, rem, StyleProps } from '@bonusly/design-system';

import { TagButton } from './tag-button';

export type HashtagButtonProps = StyleProps;

export const HashtagButton = forwardRef<HashtagButtonProps, 'button'>((props, ref) => {
	return <TagButton tag="hashtag" p={{ base: rem(4), sm: 'auto' }} pr={{ base: rem(12), sm: 'auto' }} {...props} ref={ref} />;
});
